// StoreManagerApprovalModal.js
import React, { useEffect, useState } from "react";
import * as RB from "react-bootstrap";
import * as utils from "../../Utils/comman";

const StoreManagerApprovalModal = ({
  show,
  onHide,
  selectedOrder,
  getPurchaseOrder,
}) => {
  const [plantLocation, setPlantLocation] = useState("");
  const [challanNo, setChallanNo] = useState("");
  const [remark, setRemark] = useState("");
  const [validated, setValidated] = useState(false);
  const [plantList, setPlantList] = useState([]);

  useEffect(() => {
    getPlantList();
  }, []);

  const getPlantList = () => {
    utils
      .callAPI("get", `/purchaseorder/plant/list`)
      .then((res) => {
        if (typeof res !== "undefined") {
          setPlantList(res?.result);
        } else {
          setPlantList([]);
        }
      })
      .catch((err) => {
        setPlantList([]);
      });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    e.stopPropagation();

    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      setValidated(true);
      return;
    }

    setValidated(true);
    handleApprovalSubmit();
  };

  const handleApprovalSubmit = async () => {
    const bodyFormData = new FormData();
    bodyFormData.append("po_id", selectedOrder.id);
    bodyFormData.append("plant_id", plantLocation);
    bodyFormData.append("challan", challanNo);
    bodyFormData.append("remark", remark);

    try {
      const res = await utils.callAPI(
        "post",
        `/purchaseorder/material-inward-approval`,
        bodyFormData
      );
      if (res) {
        getPurchaseOrder();
        resetFormFields();
        onHide();
        setValidated(false);
      }
    } catch (err) {
      // setError("Failed to submit approval. Please try again.");
    }
  };

  const resetFormFields = () => {
    setPlantLocation("");
    setChallanNo("");
    setRemark("");
  };

  return (
    <RB.Modal show={show} onHide={onHide}>
      <RB.Modal.Header closeButton>
        <RB.Modal.Title>Store Manager Approval</RB.Modal.Title>
      </RB.Modal.Header>
      <RB.Modal.Body>
        <RB.Form noValidate validated={validated} onSubmit={handleSubmit}>
          <div className="mb-3">
            <RB.FloatingLabel
              controlId="plantLocation"
              label="Plant Location"
              className="floating-label-fancy"
            >
              <RB.Form.Select
                value={plantLocation}
                onChange={(e) => setPlantLocation(e.target.value)}
                required
              >
                <option value="">Select Plant Location</option>
                {plantList.map((plant) => (
                  <option key={plant.id} value={plant.id}>
                    {plant.plant_name}
                  </option>
                ))}
                {/* Add more options as necessary */}
              </RB.Form.Select>
              <RB.Form.Control.Feedback type="invalid">
                Please select a plant location.
              </RB.Form.Control.Feedback>
            </RB.FloatingLabel>
          </div>

          <div className="mb-3">
            <RB.FloatingLabel
              controlId="challanNo"
              label="Challan No. / Invoice No."
              className="floating-label-fancy"
            >
              <RB.Form.Control
                type="text"
                placeholder="Enter Challan No."
                value={challanNo}
                onChange={(e) => setChallanNo(e.target.value)}
                required
              />
              <RB.Form.Control.Feedback type="invalid">
                Please enter a Challan No. or Invoice No.
              </RB.Form.Control.Feedback>
            </RB.FloatingLabel>
          </div>

          <div className="mb-3">
            <RB.FloatingLabel
              controlId="remark"
              label="Remark"
              className="floating-label-fancy"
            >
              <RB.Form.Control
                as="textarea"
                type="text"
                placeholder="Enter Remark"
                value={remark}
                onChange={(e) => setRemark(e.target.value)}
              />
            </RB.FloatingLabel>
          </div>

          <div className="text-end mt-3">
            {/* <RB.Button
              onClick={onHide} // Close modal on cancel
              variant="dark"
            >
              Cancel
            </RB.Button> */}
            <RB.Button type="submit" variant="primary" className="ms-1">
              Approve
            </RB.Button>
          </div>
        </RB.Form>
      </RB.Modal.Body>
    </RB.Modal>
  );
};

export default StoreManagerApprovalModal;
